<template>
  <mobile-reset-email v-if="isMobile" />
  <desktop-reset-email v-else />
</template>

<script>
  import { isMobile } from 'mobile-device-detect'
  import MobileResetEmail from '../../mobile/login/ResetEmail'
  import DesktopResetEmail from '../../desktop/login/ResetEmail'

  export default {
    name: 'common-reset-email',
    components: {
      'mobile-reset-email': MobileResetEmail,
      'desktop-reset-email': DesktopResetEmail
    },
    data () {
      return {
        isMobile
      }
    }
  }
</script>
